// src/ctapi/patchNotesService.js
const patchNotesData = [
    {
        version: '1.3.0',
        date: '2025-11-24',
        title: 'Summary Reports & Scheduling',
        category: 'Frontend',
        notes: [
            { type: 'new', description: 'Introduced the "Summary Report" view for high-level pipeline analytics.' },
            { type: 'new', description: 'Added Meeting Scheduler integration to streamline interview coordination.' },
            { type: 'new', description: 'Added Google Meet integration to generate Meet links when scheduling interviews.' },
            { type: 'improvement', description: 'Enhanced data visualization for candidate trend metrics.' },
            { type: 'fix', description: 'Resolved display issues in the report date picker.' },
        ],
    },
    {
        version: '1.2.0',
        date: '2025-08-15',
        title: 'The "What\'s New" Update',
        category: 'Frontend',
        notes: [
            { type: 'new', description: 'Added a "What\'s New" feature to display patch notes.' },
            { type: 'improvement', description: 'Improved the performance of the passive candidate search.' },
            { type: 'fix', description: 'Fixed a bug where the application would crash on invalid date formats.' },
        ],
    },
    {
        version: '1.1.0',
        date: '2025-07-20',
        title: 'Calendar & UI Polish',
        category: 'Frontend',
        notes: [
            { type: 'new', description: 'Integrated Google Calendar for scheduling interviews.' },
            { type: 'improvement', description: 'Redesigned the user settings page for better usability.' },
        ],
    },
    {
        version: '1.0.0',
        date: '2025-06-01',
        title: 'Initial Release',
        category: 'General',
        notes: [
            { type: 'new', description: 'Initial release of the Candidate Tools application.' },
        ],
    },
    {
        version: '0.9.0',
        date: '2025-05-15',
        title: 'Backend Performance Boost',
        category: 'Backend',
        notes: [
            { type: 'improvement', description: 'Optimized database queries for faster data retrieval.' },
            { type: 'fix', description: 'Resolved an issue with API rate limiting.' },
        ],
    }
];

export const listPatchNotes = async () => {
  console.log("API: Fetching all patch notes...");
  await new Promise(resolve => setTimeout(resolve, 500));
  return { results: patchNotesData };
};